import municipalities from "@/data/italianMunicipalities.json";
import { Label } from "@/components/ui/label";

const selectClass = "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring";

export default function LocationSelect({ provincia = "", comune = "", onChange, required = false, provinceLabel = "Provincia", comuneLabel = "Comune" }) {
  const selected = municipalities.find((p) => p.name === provincia);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>{provinceLabel}{required ? " *" : ""}</Label>
        <select className={selectClass} value={provincia} required={required} onChange={(e) => onChange({ provincia: e.target.value, comune: "" })}>
          <option value="">Seleziona provincia</option>
          {municipalities.map((p) => <option key={`${p.code}-${p.name}`} value={p.name}>{p.name} ({p.code})</option>)}
        </select>
      </div>
      <div className="space-y-2">
        <Label>{comuneLabel}{required ? " *" : ""}</Label>
        <select className={selectClass} value={comune} required={required} disabled={!selected} onChange={(e) => onChange({ provincia, comune: e.target.value })}>
          <option value="">{selected ? "Seleziona comune" : "Prima scegli la provincia"}</option>
          {(selected?.municipalities || []).map((name) => <option key={name} value={name}>{name}</option>)}
        </select>
      </div>
    </div>
  );
}
